export const RefundRequestConfig = {
  api: {},
  events: {
    refundRequestPopup: 'RefundRequestPopup',
  },
}
